import sessionStorage from 'sessionstorage'

const getTourKey = locID => `${locID}_tourID`

class SessionStorage {
    static getItem(key) {
        return sessionStorage.getItem(key)
    }

    static setItem(key, data) {
        sessionStorage.setItem(key, data)
    }

    static getTourID(locID) {
        const tourKey = getTourKey(locID)

        return this.getItem(tourKey)
    }

    static setTourID(locID, tourID) {
        const tourKey = getTourKey(locID)

        this.setItem(tourKey, tourID)
    }
}

export default SessionStorage
